import * as images from "@/components/images/Images";
import { ServicesIndustryIndustryCard } from "./types";

const contentEnterprise = {
  title: "Scale globally with industry specialized translators",
  description:
    "Accurate, context-aware precision for even the most technical and complex professional business translations",
} as const;

const cardsEnterprise: ServicesIndustryIndustryCard[] = [
  {
    title: "Education",
    description:
      "Specialized translations for educational reports, academic documents, and instructional materials, ensuring accuracy, clarity, and compliance with educational standards.",
    linkLabel: "Learn more",
    link: "/use-cases/academic",
    imageUrl: images.img1,
  },
  {
    title: "Finance",
    description:
      "Specialized translations for financial reports, statements, and documents that maintain technical integrity, and regulatory precision.",
    linkLabel: "Learn more",
    link: "/use-cases/financial",
    imageUrl: images.img2,
  },
  {
    title: "Government",
    description:
      "Specialized translations for official documents, policies, and reports, ensuring accuracy, clarity, and compliance with regulatory standards.",
    linkLabel: "Learn more",
    link: "/industries/government",
    imageUrl: images.img3,
  },
  {
    title: "Healthcare",
    description:
      "Expert translations for medical records, research papers, and patient documents, maintaining precision, confidentiality, and adherence to healthcare regulations.",
    linkLabel: "Learn more",
    link: "/use-cases/medical",
    imageUrl: images.img4,
  },
  {
    title: "Law",
    description:
      "Professional translations for legal contracts, court documents, and compliance materials, ensuring accuracy, technical integrity, and alignment with legal standards.",
    linkLabel: "Learn more",
    link: "/use-cases/legal",
    imageUrl: images.img5,
  },
  {
    title: "Explore industries",
    linkLabel: "See all",
    link: "/industries",
    imageUrl: images.explore,
    isStatic: true,
  },
];

export const servicesIndustryCardsMap = {
  enterprise: {
    content: contentEnterprise,
    cards: cardsEnterprise,
  },
};
